import axios from 'axios';

export default async function restoreDeletedLocationGroup({
  accessToken,
  id,
  setTokenLikeExpired,
}) {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_LOCATION_GROUPS_API_URL}/restore-deleted/${id}`, null,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return data;
  } catch (err) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return null;
  }
}
